function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, Progress, Select, Space, Switch } from 'antd';
import { EveryParamsByTrue, compose, getSearchTransform, isFn, usingToolTip, sortFn, usingExpandCol } from "../tools";
import { formItemClassName, superTableWarpId } from "../constants";
import { Consumer, context } from "../context";
import { computeNodesOperateClassification } from "./elementNode";
import { DownOutlined, UpOutlined } from '@ant-design/icons';
var composeFormSort = compose([function (param) {
  return sortFn(param, 'formOrder');
}]);

/*
    生成form的 item 元素
 */
function valueGenerator(formItem, ref, _ref) {
  var _formItem$formItemPro, _formItem$renderFormI, _generAtorMap;
  var formItemsStyle = _ref.formItemsStyle;
  var generAtorMap = {
    text: function text(_selfFormItem) {
      return /*#__PURE__*/React.createElement(Input, _extends({
        placeholder: "\u8BF7\u8F93\u5165"
      }, _selfFormItem.fieldProps));
    },
    select: function select(_selfFormItem) {
      var valueEnum = _selfFormItem.valueEnum;
      var selectList = Object.keys(valueEnum || {});
      return /*#__PURE__*/React.createElement(Select, _extends({
        placeholder: "\u8BF7\u9009\u62E9"
      }, _selfFormItem.fieldProps), selectList.map(function (key) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          key: key,
          value: key
        }, valueEnum === null || valueEnum === void 0 ? void 0 : valueEnum[key].text);
      }));
    },
    textarea: function textarea(_selfFormItem) {
      return /*#__PURE__*/React.createElement(Input.TextArea, _extends({
        placeholder: "\u8BF7\u8F93\u5165"
      }, _selfFormItem.fieldProps));
    },
    date: function date(_selfFormItem) {
      return /*#__PURE__*/React.createElement(DatePicker, _extends({
        placeholder: "\u8BF7\u9009\u62E9"
      }, _selfFormItem.fieldProps));
    },
    progress: function progress(_selfFormItem) {
      return /*#__PURE__*/React.createElement(Progress, _selfFormItem.fieldProps);
    },
    switch: function _switch(_selfFormItem) {
      return /*#__PURE__*/React.createElement(Switch, _selfFormItem.fieldProps);
    }
  };
  var isFnResult = isFn(formItem.renderFormItem);
  var transform = getSearchTransform(formItem.search);
  var itemPropsObject = usingToolTip(_objectSpread(_objectSpread({
    key: formItem.key || formItem.dataIndex,
    label: formItem.title,
    name: formItem.key || formItem.dataIndex,
    style: formItemsStyle,
    normalize: transform
  }, formItem.formItemProps), {}, {
    className: "super_form_item ".concat(formItemClassName, " ").concat((_formItem$formItemPro = formItem.formItemProps) === null || _formItem$formItemPro === void 0 ? void 0 : _formItem$formItemPro.className),
    labelTooltip: formItem.labelTooltip,
    labelTooltipSliceLen: formItem.labelTooltipSliceLen
  }));
  return /*#__PURE__*/React.createElement(Form.Item, itemPropsObject, isFnResult ? (_formItem$renderFormI = formItem.renderFormItem) === null || _formItem$renderFormI === void 0 ? void 0 : _formItem$renderFormI.call(formItem, formItem, {
    fieldProps: formItem.fieldProps || {}
  }, ref) : (_generAtorMap = generAtorMap[formItem.valueType || 'text']) === null || _generAtorMap === void 0 ? void 0 : _generAtorMap.call(generAtorMap, formItem));
}

/*
    生成form  绑定form的按钮
    默认会带内部的 操作按钮
 */
function GenerAtorFrom() {
  var _search, _col;
  var col = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ref = arguments.length > 1 ? arguments[1] : undefined;
  col = composeFormSort(col);
  var _getSuperTableProps = getSuperTableProps(),
    search = _getSuperTableProps.search;
  search = search || {};
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isUseExpand = _useState2[0],
    setIsUseExpand = _useState2[1];
  var _useState3 = useState(!((_search = search) !== null && _search !== void 0 && _search.defaultExpand)),
    _useState4 = _slicedToArray(_useState3, 2),
    isShowExpand = _useState4[0],
    setIsShowExpand = _useState4[1];
  var _useState5 = useState(3),
    _useState6 = _slicedToArray(_useState5, 2),
    sliceCount = _useState6[0],
    setSliceCount = _useState6[1];
  var contextData = useContext(context);
  var maxLength = ((_col = col) === null || _col === void 0 ? void 0 : _col.length) || 0;
  var computeViewFn = function computeViewFn() {
    computeNodesOperateClassification(formItemClassName, superTableWarpId).then(function (res) {
      if (res === 'reduce') {
        // 执行减法操作 最少保留一个
        setSliceCount(function (v) {
          if (v <= 1) {
            return v;
          } else {
            return v - 1;
          }
        });
        if (sliceCount < 1) {
          setTimeout(function () {
            computeViewFn();
          }, 0);
        }
      } else if (res === 'add') {
        // 逐个增加 最大数量为col的length
        setTimeout(function () {
          setSliceCount(function (v) {
            if (v >= maxLength) {
              return v;
            } else {
              return v + 1;
            }
          });
          if (sliceCount <= maxLength) {
            computeViewFn();
          }
        }, 0);
      }
    });
  };
  var computeView = computeViewFn;
  useEffect(function () {
    computeView();
  }, []);

  /**
   *  展开收起的页面节点
   * @returns
   */
  var isExpand = function isExpand() {
    if (isShowExpand) {
      return /*#__PURE__*/React.createElement(Button, {
        type: "link",
        onClick: function onClick() {
          setIsShowExpand(false);
          if (search && _typeof(search) === 'object') {
            var _search2, _search2$onExpandChan;
            (_search2 = search) === null || _search2 === void 0 || (_search2$onExpandChan = _search2.onExpandChange) === null || _search2$onExpandChan === void 0 || _search2$onExpandChan.call(_search2, false);
          }
        },
        className: "expand_button"
      }, "\u5C55\u5F00", /*#__PURE__*/React.createElement(DownOutlined, null));
    } else {
      return /*#__PURE__*/React.createElement(Button, {
        type: "link",
        onClick: function onClick() {
          setIsShowExpand(true);
          if (search && _typeof(search) === 'object') {
            var _search3, _search3$onExpandChan;
            (_search3 = search) === null || _search3 === void 0 || (_search3$onExpandChan = _search3.onExpandChange) === null || _search3$onExpandChan === void 0 || _search3$onExpandChan.call(_search3, true);
          }
        },
        className: "expand_button"
      }, "\u6536\u8D77", /*#__PURE__*/React.createElement(UpOutlined, null));
    }
  };
  return /*#__PURE__*/React.createElement(Consumer, null, function (initValue) {
    var search = initValue.search,
      searchConfig = initValue.searchConfig,
      layout = initValue.layout,
      formProps = initValue.formProps,
      formItemsStyle = initValue.formItemsStyle,
      isAutoComputeFormLine = initValue.isAutoComputeFormLine;
    var _ref2 = search || {},
      getData = _ref2.getData,
      resetData = _ref2.resetData;
    // 合并状态
    var mergeExpand = (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.expand) && isUseExpand;
    var formColItemArr = usingExpandCol({
      data: col,
      expand: mergeExpand,
      sliceCount: sliceCount,
      isShowExpand: isShowExpand
    });
    var totalFormColItemArr = usingExpandCol({
      data: col,
      expand: false,
      sliceCount: sliceCount,
      isShowExpand: isShowExpand
    });
    return /*#__PURE__*/React.createElement(Form, _extends({
      form: ref,
      layout: layout,
      className: "super_form"
    }, formProps), formColItemArr === null || formColItemArr === void 0 ? void 0 : formColItemArr.map(function (Formitem) {
      return valueGenerator(Formitem, ref, {
        formItemsStyle: formItemsStyle
      });
    }), /*#__PURE__*/React.createElement(Space, {
      className: "".concat(formItemClassName, " search_button")
    }, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: function onClick() {
        getData === null || getData === void 0 || getData();
      }
    }, searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.searchText), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        resetData === null || resetData === void 0 || resetData();
      }
    }, searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.resetText), EveryParamsByTrue(!!mergeExpand, totalFormColItemArr.length > sliceCount) ? isExpand() : null));
  });
}
var SuperTableProps;
var setSuperTableProps = function setSuperTableProps(value) {
  SuperTableProps = value;
};
var getSuperTableProps = function getSuperTableProps() {
  return SuperTableProps;
};
export { valueGenerator, GenerAtorFrom, getSuperTableProps, setSuperTableProps };